module.exports = __webpack_public_path__ + "static/media/DIAMOND.e345a295.png";